// extracted by mini-css-extract-plugin
export default {"container":"PhoneCallNavigation_container__14b1U","tabContainer":"PhoneCallNavigation_tabContainer__dMsUJ"};